import React, { useState, useEffect } from "react"
import cx from "classnames"

import { validateEmail } from "../../config/helpers"

import Select from "../Inputs/Select"
import Text from "../Inputs/Text"
import Textarea from "../Inputs/Textarea"
import Button from "../Button"

const NewsForm = ({ subjects, title }) => {
  const [progress, setProgress] = useState("none")
  const [feedback, setFeedback] = useState("")

  const [subject, setSubject] = useState(subjects[0])

  const [message, setMessage] = useState("")
  const [validMessage, setValidMessage] = useState(false)

  const [email, setEmail] = useState("")
  const [channelName, setChannelName] = useState(undefined)
  const [channelLink, setChannelLink] = useState(undefined)
  const [discordUsername, setDiscordUsername] = useState(undefined)
  const [validEmail, setValidEmail] = useState(false)

  const [fileName, setFileName] = useState(false)

  useEffect(() => {
    setValidEmail(progress === "none" || validateEmail(email))
    setValidMessage(
      progress === "none" || message.replaceAll(" ", "").length > 0
    )
  }, [email, message, progress])

  const handleSubmit = (e) => {
    e.preventDefault()

    setFeedback("")
    setProgress("pending")

    if (validEmail && message) {
      const form = new FormData(e.target)
      const options = {
        method: "POST",
        headers: {},
        body: form,
      }
      delete options.headers["Content-Type"]

      fetch("/", options)
        .then(() => {
          setProgress("success")
          setFeedback(
            "Thank you for your enquiry, we will be in touch as soon as possible."
          )
        })
        .catch(() => {
          setProgress("pending")
          setFeedback(
            "Something went wrong, please contact us directly or try again."
          )
        })
    }
  }

  useEffect(() => {
    if (subject.value !== "influencer-team") {
      setChannelLink(undefined)
      setChannelName(undefined)
      setDiscordUsername(undefined)
    }
  }, [subject])

  return (
    <div className="bg-gallery p-10 my-12 news-form-clip">
      <h3
        className={`mb-8 text-3xl md:text-2xl lg:text-3xl xl:text-4xl font-bold uppercase`}
      >
        {title}
      </h3>
      <form
        name={subject.value}
        method="post"
        data-netlify="true"
        id="contactForm"
        netlify-honeypot="bot-field"
        action=""
        onSubmit={handleSubmit}
      >
        {progress !== "success" && (
          <>
            <label className="hidden">
              Don’t fill this out if you're human: <input name="bot-field" />
            </label>
            <input type="hidden" name="form-name" value={subject.value} />
            <input type="hidden" name="subject" value={subject.label} />
            <div className="flex items-start flex-col md:flex-row">
              <Select
                {...{
                  name: "subject",
                  color: "dark",
                  placeholder: "Choose subject",
                  options: subjects,
                  value: subject.value,
                  required: true,
                  className:
                    "w-full py-2 mb-4 md:mb-0 text-base text-black placeholder-white border-black",
                  setValue: (e) =>
                    setSubject(subjects.find(({ value }) => value === e)),
                }}
              />
              <div className="w-full md:w1/2 mb-4 md:mb-0 md:ml-8">
                <Text
                  {...{
                    name: "email",
                    placeholder: "Email",
                    value: email,
                    className:
                      "w-full py-2 text-base text-black placeholder-white",
                    required: true,
                    changeHandler: ({ currentTarget: { value } }) =>
                      setEmail(value),
                  }}
                />
                {!validEmail && (
                  <p className="mt-4 text-red font-normal">
                    *Enter valid email
                  </p>
                )}
              </div>
            </div>
            {subject.value === "influencer-team" && (
              <>
                <div className="flex items-start flex-col md:flex-row">
                  <div className="w-full md:w-1/2 mb-4 md:mb-0">
                    <Text
                      {...{
                        name: "channel-name",
                        placeholder: "Channel Name",
                        value: channelName,
                        className:
                          "w-full py-2 text-base text-black placeholder-white",
                        required: false,
                        changeHandler: ({ currentTarget: { value } }) =>
                          setChannelName(value),
                      }}
                    />
                  </div>
                  <div className="w-full md:w-1/2 mb-4 md:mb-0 md:ml-8">
                    <Text
                      {...{
                        name: "channel-link",
                        placeholder: "Channel Link",
                        value: channelLink,
                        className:
                          "w-full py-2 text-base text-black placeholder-white",
                        required: false,
                        changeHandler: ({ currentTarget: { value } }) =>
                          setChannelLink(value),
                      }}
                    />
                  </div>
                </div>
                <Text
                  {...{
                    name: "discord-username",
                    placeholder: "Discord Username",
                    value: discordUsername,
                    className:
                      "w-full py-2 text-base text-black placeholder-white",
                    required: false,
                    changeHandler: ({ currentTarget: { value } }) =>
                      setDiscordUsername(value),
                  }}
                />
              </>
            )}
            <Textarea
              {...{
                name: "message",
                placeholder: "Message",
                value: message,
                required: true,
                className:
                  "w-full py-2 mt-4 text-base text-black placeholder-white",
                changeHandler: ({ currentTarget: { value } }) =>
                  setMessage(value),
              }}
            />
            {!validMessage && (
              <p className="mt-4 text-red font-normal">*Enter your message</p>
            )}
            <div className="flex flex-col md:flex-row-reverse items-start md:items-center justify-end mt-4 md:mt-8">
              <input
                id="cv"
                name="cv"
                type="file"
                className="hidden"
                data-filename={fileName || "Attach File"}
                onChange={(e) => setFileName(e.target?.files?.[0]?.name)}
              />
              <label
                htmlFor="cv"
                className="inline-flex items-center py-2 px-4 md:px-6 md:ml-4 font-bold uppercase cursor-pointer border-2 border-solid outline-none transition duration-200 text-lg bg-black hover:bg-white border-black text-white hover:text-black"
              >
                {fileName || "Attach File"}
              </label>
              <Button
                clickHandler={() => true}
                type="submit"
                className="mt-4 md:mt-0 px-12 hover:bg-secondary hover:border-secondary"
              >
                Submit
              </Button>
            </div>
          </>
        )}
        {feedback && <p className="mt-4 text-white font-normal">{feedback}</p>}
      </form>
    </div>
  )
}

export default NewsForm
